import moment from 'moment/moment';

import { CalendarEvent, CalendarEventEntity } from './types';

const DEFAULT_TIMED_DURATION_MINUTES = 30;

const parseLocalDate = (value: string): Date => {
  const [datePart] = value.split('T');
  const [year, month, day] = datePart.split('-').map(Number);

  return new Date(year, month - 1, day);
};

export class CalendarEventMapper {
  public static mapToCalendarEvent(list: CalendarEventEntity[]): CalendarEvent[] {
    return list.map(event => {
      const base = {
        id: event.id,
        title: event.subject,
        allDay: event.allDay,
        priority: event.priority,
        status: event.activityStatus,
        description: event.description ?? null,
      };

      if (event.allDay && event.startDate) {
        const start = parseLocalDate(event.startDate);

        const end = event.endDate
          ? moment(parseLocalDate(event.endDate)).add(1, 'day').toDate()
          : moment(start).add(1, 'day').toDate();

        return {
          ...base,
          start,
          end,
          durationMinutes: moment(end).diff(start, 'minutes'),
        };
      }

      const start = moment(event.startAt ?? event.startDate ?? undefined).toDate();

      const end =
        event.endAt || event.endDate
          ? moment(event.endAt || event.endDate).toDate()
          : moment(start).add(DEFAULT_TIMED_DURATION_MINUTES, 'minutes').toDate();

      return {
        ...base,
        start,
        end,
        durationMinutes: moment(end).diff(start, 'minutes'),
      };
    });
  }
}
